"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";

/**
 * Client boundary for next-themes. The class strategy is what the `dark`
 * custom variant in globals.css keys off, and `system` is the default so the
 * app matches the phone's appearance setting until she picks otherwise.
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="light"
      enableSystem
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
